
<div class="order-ticket p-3">
  <div class="order-ticket-body _h-auto">
    @if (!$storage.isDelivery) {
      <div class="ticket-box text-center">
        <h4>{{'PO.TABLE_BILL' | translate}} {{$storage.order.printData.variables.TABLE_NO}}</h4>
        <div class="mt-1">{{'PO.WAITER' | translate}} {{$storage.order.printData.variables.F_NAME}} {{$storage.order.printData.variables.L_NAME && $storage.order.printData.variables.L_NAME[0]}}</div>
        <hr />
      </div>
    }
    @if ($storage.isOTC) {
      <div class="ticket-box text-center">
        <div>
          {{'PO.ORDER_NO' | translate}}:&nbsp;<div class="inline">{{$storage.order.printData.variables.ORDER_NO}}</div>
        </div>
        <div>
          {{'PO.ORDERER_NAME' | translate}}:&nbsp;<div class="inline">{{$storage.order.printData.variables.ORDERER_NAME}}</div>
        </div>
        <div>
          {{'PO.ORDERER_PHONE' | translate}}:&nbsp;<div class="inline">{{$storage.order.printData.variables.ORDERER_TEL}}</div>
        </div>
        @if ($storage.$deliveryAddress) {
          <div>
            {{'PO.ORDER_TO' | translate}}:&nbsp;<div class="inline">{{$storage.$deliveryAddress}}</div>
          </div>
        }
        <hr />
      </div>
    }

    @if ($storage.showPrices) {
      <div class="ticket-box">
        @if (isUS) {
          <table class="ticket-box-table _md">
            <tr>
              <th>{{'PO.ORDER_TOTAL' | translate}}</th>
              <td>{{$storage.order.printData.variables.TOTAL_AMOUNT | number:'1.2-2'}}</td>
            </tr>
            @if ($storage.order.printData.variables.ORDER_ON_THE_HOUSE == '1') {
              <tr>
                <th colspan="2">{{'PO.TICKET_OTH' | translate}}</th>
              </tr>
            }
            @if ($storage.order.printData.variables.TOTAL_PAYMENTS) {
              <tr>
                <th>{{'PO.PAID' | translate}}</th>
                <td>{{($storage.order.printData.variables.TOTAL_PAYMENTS - $storage.order.printData.variables.CHANGE) | number:'1.2-2'}}</td>
              </tr>
            }
            @if ($storage.order.printData.variables.CHANGE) {
              <tr>
                <th>{{'PO.CHANGE' | translate}}</th>
                <td>{{$storage.order.printData.variables.CHANGE | number:'1.2-2'}}</td>
              </tr>
            }
            @if ($storage.order.printData.variables.BAL_DUE !== $storage.order.printData.variables.TOTAL_AMOUNT) {
              <tr class="font-bold">
                <th>{{'PO.REMAINED_PAY' | translate}}</th>
                <td>{{$storage.order.printData.variables.BAL_DUE | number:'1.2-2'}}</td>
              </tr>
            }
          </table>
        }
        @if (!isUS) {
          <table class="ticket-box-table _md">
            <tr>
              <th>{{'PO.ORDER_TOTAL' | translate}}</th>
              <td>{{$storage.order.printData.variables.TOTAL_AMOUNT | number:'1.2-2'}}</td>
            </tr>
            @if ($storage.order.printData.variables.ORDER_ON_THE_HOUSE == '1') {
              <tr>
                <th colspan="2">{{'PO.TICKET_OTH' | translate}}</th>
              </tr>
            }
            @if ($storage.order.printData.variables.TOTAL_TIPS) {
              <tr>
                <th>{{'PO.ORDER_TIP' | translate}}</th>
                <td>{{$storage.order.printData.variables.TOTAL_TIPS | number:'1.2-2'}}</td>
              </tr>
            }
            @if ($storage.order.printData.variables.TOTAL_PAYMENTS) {
              <tr>
                <th>{{'PO.PAID' | translate}}</th>
                <td>{{($storage.order.printData.variables.TOTAL_PAYMENTS - $storage.order.printData.variables.CHANGE) | number:'1.2-2'}}</td>
              </tr>
            }
            @if ($storage.order.printData.variables.CHANGE) {
              <tr>
                <th>{{'PO.CHANGE' | translate}}</th>
                <td>{{$storage.order.printData.variables.CHANGE | number:'1.2-2'}}</td>
              </tr>
            }
            @if ($storage.order.printData.variables.BAL_DUE !== $storage.order.printData.variables.TOTAL_AMOUNT) {
              <tr class="font-bold">
                <th>{{'PO.REMAINED_PAY' | translate}}</th>
                <td>{{$storage.order.printData.variables.BAL_DUE | number:'1.2-2'}}</td>
              </tr>
            }
          </table>
        }
      </div>
      @if (isUS) {
        <div class="ticket-box">
          <hr/>
          <table class="ticket-box-table _md">
            <tr>
              <th>{{'Subtotal' | translate}}</th>
              <td>{{$storage.order.printData.variables.INCLUSIVE_NET_AMOUNT | number:'1.2-2'}}</td>
            </tr>
            @if ($storage.order.fees) {
              <tr>
                <th>{{'Fees' | translate}}</th>
                <td>{{$storage.order.fees | number:'1.2-2'}}</td>
              </tr>
            }
            @if ($storage.order.autoGratuity) {
              <tr class="">
                <th>{{$storage.order.autoGratuity.name}}</th>
                <td>{{$storage.order.autoGratuity.amount | number:'1.2-2'}}</td>
              </tr>
            }
            @if (args.totalTips) {
              <tr>
                <th>{{'PO.ORDER_TIP' | translate}}</th>
                <td>{{args.totalTips | number:'1.2-2'}}</td>
              </tr>
            }
            @if ($storage.order.totals.totalExcludedTax) {
              <tr>
                <th>
                  {{'Sales Tax' | translate}}
                </th>
                <td>
                  {{($storage.order.totals.totalExcludedTax / 100) | number:'1.2-2'}}
                </td>
              </tr>
            }
          </table>
        </div>
      }
    }

  </div>


  <div class="order-ticket-header">{{'split_amount_topay' | translate}}</div>

  <div>
    @for (check of $storage.order.checks; track check; let index = $index) {
      <div class="order-ticket-check" [class._paid]="!check.$$balanceDue" (mousedown)="_onCheckSelect(check)">
        <div class="me-4 flex-grow-1" style="overflow:hidden">
          <div class="_table">
            <div [class.first]="!check.$$balanceDue || check.$$balanceDue == check.$$total">
              <div class="_cap">{{appService.translate('split_check_name', {v: check.number})}}</div>
              <div class="_amount">{{(check.$$total) | lcurrency:'1.2-2'}}</div>
            </div>
            @if (check.$$balanceDue && check.$$balanceDue != check.$$total) {
              <div class="first">
                <div class="_cap">{{'PO.REMAINED_PAY' | translate}}</div>
                <div class="_amount">{{check.$$balanceDue | lcurrency}}</div>
              </div>
            }
            @if (check.payments?.length) {
              <hr class="m-0" />
              @for (pm of check.payments; track pm) {
                @if (pm) {
                  <div class="_more">
                    <div class="_cap">{{pm.name | translate}}</div>
                    @if (pm.tip) {
                      <div class="_tip ms-2">
                        (<span class="inline">{{'gratuity' | translate}}: </span>
                        {{pm.tip | lcurrency:'1.2-2'}})
                      </div>
                    }
                    <div class="_amount ms-2">{{pm.total | lcurrency:'1.2-2'}}</div>
                  </div>
                }
              }
            }
          </div>
        </div>
        @if (check.$$balanceDue) {
          <mat-icon class="lg">{{appService.nextIcon}}</mat-icon>
        }
        @if (!check.$$balanceDue) {
          <mat-icon class="lg text-accent" svgIcon="check"></mat-icon>
        }
      </div>
    }
  </div>


  <!--<img style="width:20%; display:block; margin: 25px auto 0 auto" *ngIf="$storage.siteLogoURL" src="{{$storage.siteLogoURL}}" onerror="this.style.display = 'none'"/>-->


  <div class="text-center" style="margin-top: 20px">
    <div class="ticket-box-powered">
      <div class="no-wrap">Powered By</div>
      <img src="/assets/images/logo-light.svg" />
    </div>
  </div>


</div>
